export class A3LCompanyAgreements {
    id: string;
    agreementCode: string;
    description: string;
    field: string;
    startValidityDate: string;
    endValidityDate: string;
    revision: number;


    // public get id() : string {
    //   return `${this.agreementCode}-${this.revision}`;
    // }


}
